import { DefaultTheme } from 'styled-components';
import { mixColors } from './utils';

const theme: DefaultTheme = {
  colors: {
    black: '#000000',
    bgPage: '#09090B',
    bgPage2: mixColors('#09090B', '#ffffff', 0.05),
    bgDefault: '#FFFFFF1A',
    bgDefaultSecondary: '#FFFFFF0D',
    bgActive: '#FFFFFF1A',

    navigation: '#27272A',
    divider: '#FFFFFF1A',
    navigationDivider: '#2f3237',
    textPrimary: '#FAFAFA',
    textRegular: '#A1A1AA',
    textDisabled: '#FFFFFF1A',
    textActive: '#E4E4E7', // for tabs
    textPlaceholder: '#A1A1AA66',
    textPrimaryInformation: '#09090B',

    inputBackground: mixColors('#09090B', '#ffffff', 0.1),
    inputBorderActive: mixColors('#09090B', '#ffffff', 0.15),

    inputTextPlaceholder: mixColors('#09090B', '#A1A1AA', 0.4),
    inputTextActive: '#FAFAFA',

    fieldBackground: '#3F3F46',
    buttonPrimary: '#1DEA99',
    buttonSecondary: '#FCB61D',
    buttonTertiary: '#FF5A5A',
    buttonTextColor: '#09090B',

    zinc800: '#27272A',
    primary: '#1DEA99',
    secondary: '#FCA92A',

    highlight: '#F271CD',

    highlightBg: '#564065',
    transparentBg: 'rgba(242, 245, 250, 0.04)',

    text: '#ffffff',
    white: '#ffffff',
    textDefault: '#a7aec8',
    textTransparent: 'rgba(255, 255, 255, 0.6)',
    textSecondary: '#F2F5FA',

    // older colors
    primaryBorder: '#3beba8',
    primaryHighlight: '#70ffbc',

    // Mixed backgrounds
    primaryBg: 'rgba(59, 235, 168, 0.1)',
    secondaryBg: 'rgba(252, 169, 42, 0.1)',
    ternaryBg: 'rgba(229, 64, 115, 0.1);',

    transparentPrimaryBg: 'rgba(59, 235, 168, 0.3)',
    transparentSecondaryBg: 'rgba(252, 169, 42, 0.3)',
    transparentTernaryBg: 'rgba(229, 64, 115, 0.3)',

    textDanger: '#E54073',
    textSuccess: '#24CB8C',

    sectionBorder: '#585e7e',
    sectionDivider: '#7f89bb',

    elementBgSuccess: 'rgba(59, 235, 168, 0.16)',
    elementBgDanger: 'rgba(229, 64, 115, 0.16)',

    bgDanger: 'rgba(229, 64, 115, 0.16);',
  },

  dimensions: {
    sectionBorderRadius: '8px',
    readableColumnWidth: '680px',
    largeColumnWidth: 'calc(100vw + (2000px / 3))', // full width - 2 margins (computed at 1/3 screen - readable content (nav + readable col width))
    spacing: {
      default: {
        top: '32px',
        bottom: '12px',
      },
    },
  },

  fonts: {
    playground: `IBM Plex Mono, source-code-pro, monospace`,
  },

  shadows: {
    default: '0px 0px 20px rgba(0, 0, 0, 0.4)',
  },
};

// exported from colors logos manually
export const TOPIC_TO_COLOR = {
  SQL: mixColors('#20B9EB', '#09090B', 0.2),
  Python: mixColors('#FFD43B', '#09090B', 0.2),
  PowerBI: mixColors('#F2C80E', '#09090B', 0.2),
  'Data Analysis': mixColors('#E83B78', '#09090B', 0.2),
  'Know Your Data': mixColors('#E83B78', '#09090B', 0.2),
  'Data 101': mixColors('#E83B78', '#09090B', 0.2),
  Spreadsheets: mixColors('#16C03B', '#09090B', 0.2),
  Tableau: mixColors('#E87E39', '#09090B', 0.2),
  Looker: mixColors('#3B7DEA', '#09090B', 0.2),
  'Generative AI': mixColors('#C3A6FF', '#09090B', 0.2),
};

export const COMPLEMENTARY_COLORS = {
  BLUE: mixColors('#20B9EB', '#09090B', 0.2),
  YELLOW: mixColors('#FFD43B', '#09090B', 0.2),
  MUSTARD: mixColors('#F2C80E', '#09090B', 0.2),
  PINK: mixColors('#E83B78', '#09090B', 0.2),
  GREEN: mixColors('#16C03B', '#09090B', 0.2),
  PURPLE: mixColors('#C3A6FF', '#09090B', 0.2),
  ORANGE: mixColors('#E87E39', '#09090B', 0.2),
  DARK_BLUE: mixColors('#3B7DEA', '#09090B', 0.2),
};

export default theme;
